import type { ContentStatus, ContentType } from "features/moderatorial/types";
import React from "react";
import TabBar from "ui/TabBar";

import "./FeedSwitcher.css";

const typeOptions = [
  { value: "problem" as ContentType, label: "Проблемы" },
  { value: "solution" as ContentType, label: "Решения" },
  { value: "card" as ContentType, label: "Карточки" },
  { value: "comment" as ContentType, label: "Комментарии" },
];

const statusOptions = [
  { value: "queue" as ContentStatus, label: "На проверке" },
  { value: "moderated" as ContentStatus, label: "Скрытые" },
  { value: "deleted" as ContentStatus, label: "Удалённые" },
];

type FeedSwitcherProps = {
  type: ContentType;
  status: ContentStatus;
  onChangeType: (type: ContentType) => void;
  onChangeStatus: (status: ContentStatus) => void;
};

const FeedSwitcher: React.FC<FeedSwitcherProps> = ({
  type,
  status,
  onChangeType,
  onChangeStatus,
}) => {
  return (
    <div className="feed-switcher">
      <TabBar
        value={type}
        options={typeOptions}
        onChange={onChangeType}
      />
      {type !== "comment" && (
        <TabBar
          value={status}
          options={statusOptions}
          onChange={onChangeStatus}
        />
      )}
    </div>
  );
};

export default FeedSwitcher;
